import React, { useState } from 'react';
import Select from 'react-select';

const FieldsetBloquearVendedores = ({
  usuariosDisponiveis = [],
  vendedoresSelecionados = [],
  onAdicionar,
  onRemover
}) => {
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);

  const handleAdicionar = () => {
    if (!usuarioSelecionado) return;
    onAdicionar(usuarioSelecionado);
    setUsuarioSelecionado(null);
  };

  const optionsDisponiveis = usuariosDisponiveis
    .filter(u => !vendedoresSelecionados.map(v => v.value).includes(u.chave))
    .map(u => ({ label: u.valor, value: u.chave }));

  return (
    <fieldset className="scheduler-border">
      <legend className="scheduler-border">Bloquear vendedores</legend>

      <div className="col-12 col-sm-12 col-md-9">
        <Select
          placeholder="Adicionar vendedor"
          value={usuarioSelecionado}
          onChange={setUsuarioSelecionado}
          options={optionsDisponiveis}
          styles={{
            control: base => ({
              ...base,
              height: 35,
              fontSize: 16,
              borderColor: '#e4e7ea',
              cursor: 'pointer',
            }),
          }}
          noOptionsMessage={() => 'Nenhuma opção encontrada'}
        />
      </div>

      <div className="col-12 col-sm-3 col-md-2 mt-2">
        <button
          type="button"
          className="btn btn-sm btn-laranja"
          onClick={handleAdicionar}
          disabled={!usuarioSelecionado}
        >
          Incluir
        </button>
      </div>

      <div className="col-12 col-sm-12 col-md-9 mt-2">
        <div className="lista-table">
          <table className="table table-sm table-bordered">
            <thead>
              <tr className="text-center">
                <th>Usuários Selecionados</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {(!vendedoresSelecionados || vendedoresSelecionados.length === 0) ? (
                <tr className="alert alert-warning text-center mt-4" role="alert">
                  <td colSpan="2">Nenhum usuário foi selecionado.</td>
                </tr>
              ) : (
                vendedoresSelecionados.map((usuario, index) => (
                  <tr key={index}>
                    <td>{usuario.label}</td>
                    <td className="text-center" style={{ cursor: 'pointer', color: 'red' }}>
                      <div onClick={() => onRemover(usuario.value)}>Remover</div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </fieldset>
  );
};

export default FieldsetBloquearVendedores;
